import Swal from '@global/config/defaultSwal';

export async function provideSwal() {
  return Swal;
}
